<template>
  <div id="deviceMagtDetail">
    <div class="headTitle">
      <span style="font-size: 18px;">{{ $t('sim.orderNumber') }}:{{ basicinfo.orderSn }}</span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.YearsPurchase') }}：{{ basicinfo.years }}</span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.Price') }}：
        <span style="color:green">¥ {{ basicinfo.priceTotal }}</span> |
        <span style="color:blue">$ {{ basicinfo.priceUsdTotal }}</span>
      </span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.payerInfo') }}：{{ basicinfo.userName||'--' }} /
        {{ basicinfo.paymentAccount||'--' }} / {{ basicinfo.contactInfo||'--' }}</span>
    </div>
    <div class="headTitle">
      <!-- <span class="fontStyle1">{{ $t('sim.audit') }}：{{ basicinfo.auditUser||'--' }} / {{ basicinfo.auditTimeZh }}</span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.payupdateTime') }}：{{ basicinfo.updateTimeZh }}</span>
      <span class="fontStyle2" /> -->
      <span class="fontStyle1">{{ $t('warningPage.Remark') }}：{{ basicinfo.remark ||'--' }}</span>
    </div>
    <!-- 生命周期 -->
    <p class="blockTitleP" style="margin:10px 0 0 -10px;border-top: 1px solid #dcdfe6;">{{ $t('sim.lifeCycle') }}</p>
    <div class="baseContentWarp" style="padding-left: 10px;">
      <p v-if="statuList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
      <div class="stepsWarp">
        <div v-for="(item,index) in statuList" :key="index" class="stepDiv"
          :class="[{'active':currentOrder.status==item.statu},{'done':currentOrder.status>item.statu},{'next':currentOrder.status<item.statu}]">
          <p class="title">{{ item.title }}</p>
          <p class="numBox">
            <span class="leftLine line" />
            <span class="num">
              <span v-if="currentOrder.status>=item.statu" class="el-icon-check" />
              <span v-else>{{ item.statu+1 }}</span>
            </span>
            <span class="rightLine line" />
          </p>
          <p class="time">{{ item.time }}</p>
          <p class="description">{{ item.description }}</p>
        </div>
      </div>
    </div>
    <!-- 状态编辑 -->
    <div>
      <p class="blockTitleP" style="margin-top: 10px;border-top: 1px solid #dcdfe6;"> {{ $t('adminView.Edit') }}
        {{ $t('AllDevices.Status') }}</p>
      <el-form :model="currentOrder" label-position="right" label-width="150px" class="StatusForm">
        <!-- <p>{{ currentOrder.status }}-{{ currentOrder.newStatus }}</p> -->
        <div class="width50">
          <el-form-item :label="$t('AllDevices.Status')">
            <el-select v-model="currentOrder.newStatus" :placeholder="$t('button.select')" @change="change">
              <el-option v-for="item in filterStatusOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('warningPage.Remark')">
            <el-input v-model="currentOrder.auditRemark" :autosize="{ minRows: 2, maxRows: 8}"
              :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
          </el-form-item>

          <el-button class="filter-item" :disabled="currentOrder.status==currentOrder.newStatus"
            style="margin-left: 150px;  margin-bottom: 20px;" type="primary"
            @click="submitEdit(currentOrder.orderSn)">{{ $t('button.Submit') }}</el-button>

        </div>
        <div class="width50">

          <el-form-item :label="$t('sim.uploadFiles')">
            <div class="imgWarp">
              <el-upload class="upload-demo" :action="action" :on-preview="handlePreview"
                :headers="{token: $store.state.token}" name="multipartFile" :on-remove="handleRemove"
                :on-success="successUpload" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList">
                <el-button size="small" type="primary">{{ $t('QR.SelectFile') }}</el-button>
                <div slot="tip" class="el-upload__tip">{{ $t('sim.fileInfo') }}</div>
              </el-upload>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="filter-item" :disabled="currentOrder.status==currentOrder.newStatus" type="primary" @click="submitEdit(currentOrder.orderSn)">{{ $t('button.Submit') }}</el-button>
      </div> -->
    </div>
    <!-- 表格 -->
    <div class="content">
      <el-button v-if="$store.state.userInfo.guestFlag!=true" icon="el-icon-download" type="primary"
        style="float: right;margin-bottom:20px;" @click="download" />
      <el-table id="feedBackTable" :data="tableList" max-height="300" style="width: 100%" border fit
        highlight-current-row>
        <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')" align="center" />
        <el-table-column prop="deviceSn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
        <el-table-column prop="companyName" :label="$t('AllDevices.companyName')" align="center" />
        <el-table-column prop="simType" :label="$t('adminView.Type')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <p v-if="scope.row.simType==1">263 {{ $t('sim.card') }}</p>
              <p v-if="scope.row.simType==2">keepgo {{ $t('sim.card') }}</p>
              <p v-if="scope.row.simType==3">datamobile {{ $t('sim.card') }}</p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="planName" :label="$t('sim.PackageName')" align="center" /> -->
        <el-table-column prop="flowSize" :label="$t('sim.MonthlyTraffic')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              {{ scope.row.simFlowAmount }}M
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="years" :label="$t('sim.YearsPurchase')" align="center" />
        <!-- <el-table-column prop="currency" :label="$t('sim.Currency')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <p>{{ scope.row.currency==1?$t('sim.RMB'):$t('sim.Dollar') }}</p>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="price" :label="$t('sim.Price')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">

              <el-popover placement="top" width="600" trigger="click">
                <div v-if="scope.row.simType==1" class="CalculationRulesDiv">
                  <p>{{ $t('sim.CalculationRules') }}： ( 263 {{ $t('sim.card') }})</p>
                  <p>{{ $t('sim.Rule1') }}</p>
                  <p>((1 * {{ scope.row.simFlowAmount/50 }} * 12)+ {{ scope.row.serviceFeePriceByYear }}) *
                    {{ scope.row.years }} = ${{ scope.row.priceUsd }} (¥{{ scope.row.price }})</p>
                  <p>{{ $t('sim.Rule1tips') }}</p>
                </div>
                <div v-if="scope.row.simType==2" class="CalculationRulesDiv">
                  <p>{{ $t('sim.CalculationRules') }}： ( keepgo {{ $t('sim.card') }})</p>
                  <p>{{ $t('sim.Rule2') }}</p>
                  <p>(({{ scope.row.currentPricePerMb }}*{{ scope.row.simFlowAmount }} + 1.5) * 12+
                    {{ scope.row.serviceFeePriceByYear }}) * {{ scope.row.years }} = ${{ scope.row.priceUsd }}
                    (¥{{ scope.row.price }})</p>
                </div>
                <div v-if="scope.row.simType==3" class="CalculationRulesDiv">
                  <p>{{ $t('sim.CalculationRules') }}： ( datamobile {{ $t('sim.card') }})</p>
                  <!-- <p>1、非欧盟：</p> -->
                  <p v-if="!scope.row.eea">{{ $t('sim.Rule3NoEEA') }}</p>
                  <p v-if="!scope.row.eea">(({{ scope.row.currentPricePerMb }}*{{ scope.row.simFlowAmount }} + 1.7) *
                    12+ {{ scope.row.serviceFeePriceByYear }}) * {{ scope.row.years }} = ${{ scope.row.priceUsd }}
                    (¥{{ scope.row.price }})</p>
                  <!-- <p>2、欧盟：</p> -->
                  <!-- <p>   1)每月流量数50M以内(包含50M)</p> -->
                  <p v-if="scope.row.eea&&scope.row.simFlowAmount<=50">{{ $t('sim.Rule3EEA1') }}</p>
                  <p v-if="scope.row.eea&&scope.row.simFlowAmount<=50">(1.7 * 12+ {{ scope.row.serviceFeePriceByYear }})
                    * {{ scope.row.years }} = ${{ scope.row.priceUsd }} (¥{{ scope.row.price }})</p>
                  <!-- <p>   2)每月流量数大于50M</p> -->
                  <p v-if="scope.row.eea&&scope.row.simFlowAmount>50">{{ $t('sim.Rule3EEA2') }}</p>
                  <p v-if="scope.row.eea&&scope.row.simFlowAmount>50">
                    (({{ scope.row.currentPricePerMb }}*({{ scope.row.simFlowAmount }}-50) + 1.7) * 12+
                    {{ scope.row.serviceFeePriceByYear }}) * {{ scope.row.years }} = ${{ scope.row.priceUsd }}
                    (¥{{ scope.row.price }})</p>
                </div>
                <div slot="reference">
                  <span style="color:green">¥ {{ scope.row.price }}</span> |
                  <span style="color:blue">$ {{ scope.row.priceUsd }}</span>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="discount" :label="$t('sim.discountValue')" align="center" /> -->
        <el-table-column prop="areaListStr" :label="$t('sim.ServiceArea')" align="center" show-overflow-tooltip
          min-width="140px">
          <template slot-scope="scope">
            {{ language.indexOf('zh') >= 0?scope.row.countryName:scope.row.countryNameEn }}
            <span v-if="scope.row.simType==3&&scope.row.eea"> ({{ $t('sim.EEA') }})</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import { pageDataServiceOrder, updateDataServiceOrderStatus } from '@/api/sim'

export default {
  components: {
  },
  props: ['orderDetailPop'],
  data () {
    return {
      basicinfo: {
        orderSn: null,
        years: null,
        price: null,
        priceUsd: null,
        priceTotal: null,
        priceUsdTotal: null,
        auditTimeZh: null,
        auditUser: null,
        contactInfo: null,
        updateTimeZh: null,
        remark: null,
        paymentAccount: null,
        userName: null,
        currency: 1
      },
      tableList: [],
      isShowStautPop: false,
      currentOrder: {
        newStatus: null,
        auditRemark: null
      },
      filterStatusOptions: [],
      fileList: [],
      action: '#',
      statuList: []
    }
  },
  computed: {
    statusOptions () {
      return [// 状态：0未支付待审核、1待支付、2已支付待审核、3支付成功、4过期失效
        // { label: i18n.t('sim.effective'), value: 1 },
        // { label: i18n.t('sim.Expired'), value: 2 }
        { label: i18n.t('sim.unpaidReview'), value: 0 },
        { label: i18n.t('sim.PendingPay'), value: 1 },
        { label: i18n.t('sim.review'), value: 2 },
        { label: i18n.t('sim.PaySuccess'), value: 3 },
        { label: i18n.t('sim.ExpirationExpired'), value: 4 }
      ]
    },
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.initTable()
    },
    orderDetailPop (val) {
      if (val) {
        this.initTable()
      }
    }
  },
  mounted () {
    this.initTable()
  },
  methods: {
    initTable () {
      var obj = JSON.parse(sessionStorage.getItem('orderMagtRow') || '{}')
      for (var attr in this.basicinfo) this.basicinfo[attr] = obj[attr]
      this.clickStatu(obj, obj.index)
      console.log('orderMagtRow:obj', obj)
      this.tableList = JSON.parse(obj.detail || '[]')
      this.tableList.forEach(v => {
        v.discount = v.discount ? v.discount * 10 : '--'
        // var areaList = JSON.parse(v.region) || []
        // v.areaListStr = ''
        // areaList.forEach((m, i) => {
        //   if (this.$store.state.language == 'zh') {
        //     v.areaListStr += i < areaList.length - 1 ? m.countryName + ' , ' : m.countryName
        //   } else {
        //     v.areaListStr += i < areaList.length - 1 ? m.countryNameEn + ' , ' : m.countryNameEn
        //   }
        // })
      })
      console.log('this.tableList', this.tableList)
    },
    clickStatu (row, index) { // 打开状态弹窗
      this.action = process.env.VUE_APP_BASE_API + '/v3/manager/commUpload/upload/dataService'
      this.currentOrder = row
      this.currentOrder.index = index
      this.currentOrder.newStatus = this.currentOrder.status
      this.isShowStautPop = true
      this.filterStatusOptions = []
      this.fileList = []
      console.log('row', row)
      var auditFileArr = row.auditFile ? row.auditFile.split('/,') : []
      auditFileArr.forEach(v => { // 处理文件
        var fileInfo = v.split('?name=') || ['', '']
        this.fileList.push({ name: fileInfo[1], url: fileInfo[0] })
      })
      this.statusOptions.forEach(v => { // 处理状态下拉框
        if (this.currentOrder.status == 0 || this.currentOrder.status == 1 || this.currentOrder.status == 2) {
          if (v.value >= this.currentOrder.status || (v.value == 1 && this.currentOrder.status == 2)) {
            // 已支付待审核(2) 没有 过期失效(4) 选项
            // if (this.currentOrder.status != 2 && v.value != 4) this.filterStatusOptions.push(v)
            if (v.value != 4) {
              this.filterStatusOptions.push(v)
            } else {
              if (this.currentOrder.status != 2) this.filterStatusOptions.push(v)
            }
          }
        } else {
          if (v.value == this.currentOrder.status) {
            this.filterStatusOptions.push(v)
          }
        }
      })
      this.statuList = []
      this.statuList.push(
        { statu: 0, title: this.$t('sim.unpaidReview'), time: row.createTime ? getDateAndHour(row.createTime, 'noSecond') : '--', description: row.createUser },
        { statu: 1, title: this.$t('sim.PendingPay'), time: row.notPaidTime ? getDateAndHour(row.notPaidTime, 'noSecond') : '--', description: row.notPaidUser },
        { statu: 2, title: this.$t('sim.review'), time: row.paidTime ? getDateAndHour(row.paidTime, 'noSecond') : '--', description: row.paidUser },
        { statu: 3, title: this.$t('sim.PaySuccess'), time: row.auditTime ? getDateAndHour(row.auditTime, 'noSecond') : '--', description: row.auditUser },
      )
      if (this.currentOrder.status == 4) {
        this.statuList.push(
          { statu: 4, title: this.$t('sim.ExpirationExpired'), time: row.updateTime ? getDateAndHour(row.updateTime, 'noSecond') : '--', description: '' },
        )
      }
    },
    handleRemove (file, fileList) { // 删除文件
      console.log(file, fileList)
      this.fileList = fileList
    },
    handlePreview (file) { // 文件预览
      console.log(file)
      window.open(file.url, '_blank')
    },
    handleExceed (files, fileList) {
      this.$message.warning(this.$t('sim.fileInfo2'))
    },
    successUpload (res, file) { // 文件上传成功
      console.log(res, file)
      this.fileList.push({ name: file.name, url: file.response.resultModel })
    },
    change () {
      this.$forceUpdate()
    },
    submitEdit (orderSn, editStatus) { // 列表中改状态--提交
      var param = {
        orderSn: orderSn,
        status: this.currentOrder.newStatus,
        auditRemark: this.currentOrder.auditRemark,
        auditFile: ''
      }
      this.fileList.forEach((v, index) => { // 将文件名和url都保存,文件间用 /， 分隔
        if (index < this.fileList.length - 1) { param.auditFile += v.url + '?name=' + v.name + '/,' } else { param.auditFile += v.url + '?name=' + v.name }
      })
      // console.log('this.fileList--', this.fileList)
      // console.log('this.param--', param)
      this.$confirm(i18n.t('sim.sureChange'), '', {
        confirmButtonText: i18n.t('button.Confirm'),
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        // this.tableList[this.currentOrder.index].loading = true
        console.log('submitEdit:index', this.currentOrder.index)
        updateDataServiceOrderStatus(param).then(res => {
          // this.tableList[this.currentOrder.index].loading = false
          if (res.resultCode == 1001) {
            this.isShowStautPop = false
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted')
            })
            this.$emit('cancelPop')
            this.initTable()// 获取列表
          } else {
            this.$notify({
              message: res.resultMessage,
              type: 'warning',
              duration: 2000
            })
          }
        })
      }).catch(() => {

      })
    },
    download () { // 下载
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('dashboard.DeviceName'),
          i18n.t('BondOrUpdateDevice.SN'),
          i18n.t('AllDevices.companyName'),
          i18n.t('adminView.Type'),
          i18n.t('sim.MonthlyTraffic') + '(M)',
          i18n.t('sim.YearsPurchase'),
          i18n.t('sim.Price'),
          i18n.t('sim.ServiceArea')
        ]
        const filterVal = [
          'deviceName',
          'deviceSn',
          'companyName',
          'simType',
          'simFlowAmount',
          'years',
          'price',
          'areaListStr'
        ]
        const list = this.tableList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'orderDetail',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    getSimTypeName (val) {
      if (val == 1) return '263'
      if (val == 2) return 'keepgo'
      if (val == 3) return 'datamobile'
      if (val == 4) return 'simboss'
      return '--'
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'simType') {
            return this.getSimTypeName(v[j])
            // return v[j] == 1 ? '263' + this.$t('sim.card') : (v[j] == 2 ? 'keepgo' + this.$t('sim.card') : 'datamobile' + this.$t('sim.card'))
          } else if (j === 'price') {
            return `¥${v[j]} | $${v.priceUsd}`
          } else if (j === 'areaListStr') {
            var str = this.language.indexOf('zh') >= 0 ? v.countryName : v.countryNameEn
            return (v.simType == 3 && v.eea) ? str + ' (' + this.$t('sim.EEA') + ')' : str
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>

<style lang="scss">
#deviceMagtDetail {
  margin-top: -10px;
  margin-bottom: 20px;
  .content {
    background: #fff;
    //margin-top: 20px;
    // padding: 20px;
  }
  .headTitle {
    padding: 0;
    background: #f0f2f5;
    padding: 5px 20px;
    height: auto;
  }
}
.CalculationRulesDiv {
  p {
    margin: 10px;
  }
}
.width50 {
  width: calc(50% - 5px);
  display: inline-block;
}
.StatusForm {
  display: flex;
}
</style>
